import styled from "@emotion/styled";
import classNames from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import { Tag, Tooltip, List } from "antd";
import gpsImg from "../../../../images/gps.png";
import user1 from "../../../../images/user1.png";
import user2 from "../../../../images/user2.png";
import request from "../../../../utils/request";
import { DownOutlined } from "@ant-design/icons";
import { isYushan } from "../../../../config";
const CommonHeaderLayout = styled.div`
  .flex {
    display: flex;
  }
  .btn-item {
    height: 32px;
    padding: 0 30px;
    line-height: 32px;
    border-radius: 6px;
  }
  .title-box {
    align-items: center;
    .title {
      color: #feffff;
      font-size: 30px;
      font-weight: 800;
      margin-right: 30px;
      margin-bottom: 0;
    }
  }
  .pos {
    color: #10cde9;
    font-size: 20px;
    font-weight: 400;
    margin-right: 36px;
    margin-left: 10px;
  }
  .date {
    color: #aba9a9;
    font-size: 20px;
  }
  .gps {
    margin-top: 20px;
  }
  .types {
    margin-top: 30px;
    flex-wrap: wrap;
    .type-item {
      margin-bottom: 20px;
    }
  }
  .peoples {
    margin-top: 29px;
  }
  .people {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #4aa5ea;
    font-size: 16px;
    img {
      margin-bottom: 14px;
    }
  }
  .tel {
    color: #ffffff;
    font-size: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-left: 22px;
  }

  .phone2 {
    margin-top: 16px;
  }
  .people-item {
    margin-right: 84px;
  }
  .navs {
    display: flex;
    /* justify-content: space-between; */
    font-size: 22px;
    color: #fff;
    font-weight: bold;
    margin-top: 46px;
    transition: all 0.2s;
    .nav {
      cursor: pointer;
      margin-right: 20px;
      &:hover,
      &.active {
        color: #fcee21;
      }
    }
  }
`;

export const CustomButon: React.FC<{
  marginRight?: number | string;
  bgColor: string;
  color: string;
  children?: React.ReactNode;
}> = ({ marginRight = 27, bgColor, children, color }) => {
  return (
    <CommonHeaderLayout>
      <div
        className="btn-item"
        style={{
          marginRight,
          backgroundColor: bgColor,
          color,
        }}
      >
        {children}
      </div>
    </CommonHeaderLayout>
  );
};

type CommonHeaderProps = {
  onTableChange?: (index: number) => void;
  id?: number;
};

export const CommonHeader: React.FC<CommonHeaderProps> = ({
  onTableChange,
  id,
}) => {
  const tabs = isYushan
    ? [
        "基本信息",
        "土地规划",
        "项目建设",
        "政策兑现",
        "经营信息",
        "能耗信息",
        "知识产权",
        "环保信息",
        "安全信息",
        "厂房物业",
        "企业走访",
        "问题反馈",
      ]
    : [
        "基本信息",
        // "土地规划",
        "项目建设",
        // "政策兑现",
        "经营信息",
        "能耗信息",
        // "知识产权",
        "环保信息",
        "安全信息",
        // "厂房物业",
        // "企业走访",
        "问题反馈",
      ];
  const [activeIndex, setActiveIndex] = useState(0);
  const [details, setDetails] = useState<Record<string, any>>({});
  const getData = useCallback(() => {
    if (!id) return;
    request.get("/screen/Index/getCompanyDetails?id=" + id).then((res) => {
      const data = res.data?.data || {};
      // data.historyNames = [
      //   {
      //     title: "产值趋势",
      //   },
      //   {
      //     title: "产值趋势1",
      //   },
      // ];
      setDetails(data);
    });
  }, [id]);
  useEffect(() => {
    getData();
  }, [getData]);
  return (
    <CommonHeaderLayout>
      <div>
        <div className="flex title-box">
          <h2 className="title">{details.name}</h2>
          {details.historyNames && details.historyNames.length ? (
            <Tooltip
              placement="bottom"
              color="rgba(196, 29, 127,0.6)"
              // open={true}
              style={{ maxWidth: "100%" }}
              zIndex={9999991111111}
              title={
                <List
                  // header={<div>Header</div>}
                  // footer={<div>Footer</div>}
                  // bordered
                  dataSource={details.historyNames}
                  renderItem={(item: any) => (
                    <List.Item style={{ color: "#fff" }}>
                      {item.title}
                    </List.Item>
                  )}
                />
              }
            >
              {" "}
              <Tag
                color="magenta"
                style={{
                  height: 32,
                  padding: "0 30px",
                  lineHeight: "32px",
                  borderRadius: "6px",
                  fontSize: 14,
                }}
                closable
                closeIcon={<DownOutlined />}
                onClose={(e) => {
                  e.preventDefault();
                }}
              >
                曾用名
              </Tag>
            </Tooltip>
          ) : null}
          {/* <CustomButon marginRight={27} bgColor={"#CDF7E2"} color="#34A76E">
            曾用名
          </CustomButon> */}
          <CustomButon marginRight={27} bgColor={"#CDF7E2"} color="#34A76E">
            {details.industry_title}
          </CustomButon>
          <CustomButon marginRight={27} bgColor={"#F9E5C7"} color="#FAA63A">
            {details.category_title}
          </CustomButon>
        </div>
        <div className="flex gps">
          <img src={gpsImg} alt="" />
          <p className="pos">{details.address}</p>
          <span className="date">{details.settleindate} 入驻</span>
        </div>
        <div className="flex types">
          {details.tags_ary?.map((item: Record<string, any>) => {
            return (
              <div key={item.id} className="type-item">
                <CustomButon marginRight={27} bgColor="#E5ECFA" color="#6093C6">
                  {item.dkey}
                </CustomButon>
              </div>
            );
          })}
        </div>
        <div className="flex peoples">
          <div className="flex people-item">
            <div className="flex people">
              <img src={user1} alt="" />
              <p>联系人</p>
            </div>
            <div className="tel">
              <p>{details.contacts}</p>
              <p className="phone2">{details.phone}</p>
            </div>
          </div>
          <div className="flex people-item">
            <div className="flex people">
              <img src={user2} alt="" />
              <p>包保干部</p>
            </div>
            <div className="tel">
              <p>{details.cadre_name}</p>
              <p className="phone2">{details.cadre_mobile}</p>
            </div>
          </div>
          {isYushan && (
            <div className="flex people-item">
              <div className="flex people">
                <div
                  style={{
                    color: "#12D1A3",
                    fontSize: "36px",
                    fontWeight: "700",
                  }}
                >
                  {details.rating || "-"}
                </div>
                <p>亩均效益评级</p>
              </div>
              {/* <div className="tel">
              <p>{details.bbg_people}</p>
              <p className="phone2">{details.bbg_mobile}</p>
            </div> */}
            </div>
          )}
        </div>
        <div className="navs">
          {tabs.map((tab, index) => {
            return (
              <div
                key={index}
                className={classNames("nav", {
                  active: index === activeIndex,
                })}
                onClick={() => {
                  setActiveIndex(index);
                  onTableChange?.(index);
                }}
              >
                {tab}
              </div>
            );
          })}
        </div>
      </div>
    </CommonHeaderLayout>
  );
};
